// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2duGY","header":"MergedInvoice_header__3vUye"};